<template>
  <router-view></router-view>

  <Notifications />
  <VersionChecker />
  <BModalOrchestrator />
</template>

<script lang="ts" setup>
import { BModalOrchestrator } from "bootstrap-vue-next";
import VersionChecker from "@/components/VersionChecker.vue";
import Notifications from "@/components/Notifications.vue";
import { useBootstrap } from "@/bootstrap";

useBootstrap();
</script>

<style lang="scss">
@use "assets/scss/app";
$fa-font-path: "@fortawesome/fontawesome-free/fonts/";
@import "@fortawesome/fontawesome-free/css/all.min.css";
</style>
